import { Close } from '@mui/icons-material'
import { useAppServices } from 'hook/services'
import MDModal from 'components/MDModal'
import SoftSelect from 'components/SoftSelect'
import React, { useState } from 'react'
import { Tooltip } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

const categories = [
    { label: "Information", value: "INFORMATION" },
    { label: "Announcement", value: "ANNOUNCEMENT" },
    { label: "Warning", value: "WARNING" },
    { label: "Error", value: "ERROR" },
]

const linkOption = [
    { label: "In the same window", value: "SameWindow" },
    { label: "In a new window", value: "NewWindow" }
]
const AddNotificationModal = ({ open, onClose, editNotification, agency, Update }) => {
    const Service = useAppServices();
    const [loading, setLoading] = useState(false)
    const [inputs, setInputs] = useState({
        title: editNotification ? editNotification.title : "",
        message: editNotification ? editNotification.message : "",
        cta_text: editNotification ? editNotification.cta_text : "",
        cta_link: editNotification ? editNotification.cta_link : "",
        linkOption: editNotification ? linkOption.find(c => c.value === editNotification.linkOption) : "",
        category: editNotification ? categories.find(c => c.value === editNotification.category) : "",
        endDate: editNotification ? editNotification.endDate : "",
        status: editNotification ? editNotification.status : false,
    })

    const saveNotifications = async () => {
        setLoading(true);
        const oldNotifications = editNotification ? agency.notifications.filter(n => n.id !== editNotification.id) : agency.notifications;
        const notifications = [...oldNotifications, { ...inputs, category: inputs.category.value, linkOption: inputs.linkOption?.value, id: editNotification ? editNotification.id : new Date().getTime().toString() }];
        const payload = {
            notifications: notifications,
            _id: agency._id
        }
        const { response } = await Service.agency.update({ payload });
        if (response?.success) {
            Update({ notifications });
            setInputs({
                title: "",
                message: "",
                cta_text: "",
                cta_link: "",
                linkOption: "",
                category: "",
                endDate: "",
            })
            onClose()
        } else {
            alert("Failed to update Notifications")
        }
        setLoading(false)
    }

    return (
        <MDModal open={open} onClose={onClose} width="650px" height="auto" overflow="visible">
            <button onClick={onClose} style={{ cursor: "pointer", position: 'fixed', top: '10px', right: "10px", background: "transparent", border: "none", fontSize: "18px" }}><Close /></button>
            <div>
                <p style={{ fontSize: "16px", fontFamily: "Inter", fontWeight: "600" }}>{editNotification !== null ? "Edit" : "Add"} Notification</p>
                <div style={{ marginTop: "8px" }}>
                    <p style={{ fontSize: "13px", fontFamily: "Inter" }}>Notification Title</p>
                    <input type="text" value={inputs.title} onChange={(e) => setInputs({ ...inputs, title: e.target.value })} placeholder='Insert Notification Title' style={{ width: "100%", padding: "10px", borderRadius: "5px", border: "1px solid #ccc", fontSize: "16px", fontFamily: "Inter" }} />
                </div>
                <div style={{ marginTop: "12px" }}>
                    <p style={{ fontSize: "13px", fontFamily: "Inter" }}>Custom Notification message</p>
                    <input type="text" value={inputs.message} onChange={(e) => setInputs({ ...inputs, message: e.target.value })} placeholder='Insert custom message' style={{ width: "100%", padding: "10px", borderRadius: "5px", border: "1px solid #ccc", fontSize: "16px", fontFamily: "Inter" }} />
                </div>
                <div style={{ marginTop: "12px" }}>
                    <p style={{ fontSize: "13px", fontFamily: "Inter", display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "8px" }}>CTA button text
                        <Tooltip title="Include an optional CTA button so user can act on your notification with one click" placement="top" style={{ fontSize: "12px", fontFamily: "Inter", color: "#000", backgroundColor: "#fff" }}>
                            <InfoOutlinedIcon fontSize="xs" color="dark" style={{ cursor: 'pointer' }} />
                        </Tooltip>
                    </p>
                    <input type="text" value={inputs.cta_text} onChange={(e) => setInputs({ ...inputs, cta_text: e.target.value })} placeholder='Insert text here' style={{ width: "100%", padding: "10px", borderRadius: "5px", border: "1px solid #ccc", fontSize: "16px", fontFamily: "Inter" }} />
                </div>
                <div style={{ marginTop: "12px" }}>
                    <p style={{ fontSize: "13px", fontFamily: "Inter" }}>CTA button Link</p>
                    <input type="text" value={inputs.cta_link} onChange={(e) => setInputs({ ...inputs, cta_link: e.target.value })} placeholder='Insert link here' style={{ width: "100%", padding: "10px", borderRadius: "5px", border: "1px solid #ccc", fontSize: "16px", fontFamily: "Inter" }} />
                </div>
                <div style={{ marginTop: "12px" }}>
                    <p style={{ fontSize: "13px", fontFamily: "Inter", display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "8px" }}>Open link
                        <Tooltip title="Linking to another part of Maybe? Choose 'Same Window' to keep users in the platform" placement="top" style={{ fontSize: "12px", fontFamily: "Inter", color: "#000", backgroundColor: "#fff" }}>
                            <InfoOutlinedIcon fontSize="xs" color="dark" style={{ cursor: 'pointer' }} />
                        </Tooltip>
                    </p>
                    <SoftSelect options={linkOption} value={inputs.linkOption} onChange={(e) => setInputs({ ...inputs, linkOption: e })} />
                </div>
                <div style={{ marginTop: "12px" }}>
                    <p style={{ fontSize: "13px", fontFamily: "Inter" }}>Select message category</p>
                    <SoftSelect options={categories} value={inputs.category} onChange={(e) => setInputs({ ...inputs, category: e })} />
                </div>
                <div style={{ marginTop: "12px" }}>
                    <p style={{ fontSize: "13px", fontFamily: "Inter", margin: "0px" }}>Notification end date</p>
                    <span style={{ fontSize: "11px", fontFamily: "Inter", color: "#acacacff" }}>if no date is selected then banner will remain until toggled off</span>
                    <input type="date" value={inputs.endDate} onChange={(e) => setInputs({ ...inputs, endDate: e.target.value })} style={{ width: "100%", padding: "10px", borderRadius: "5px", border: "1px solid #ccc", fontSize: "16px", fontFamily: "Inter" }} />
                </div>
                <button onClick={saveNotifications} disabled={loading || !inputs.title || !inputs.message || !inputs.category} style={{ cursor: "pointer", background: "black", color: "white", padding: "10px 20px", borderRadius: "3px", border: "none", marginTop: "20px", width: "100%", fontSize: "14px", fontFamily: "Inter", fontWeight: "600" }}>{loading ? 'wait...' : 'Save Notification'}</button>
            </div>
        </MDModal >
    )
}

export default AddNotificationModal